<div class="modal-header justify-content-center">
    <div class="text-center">
        <h5 class="modal-title">{{'home.recordpickup.confirmCompletion' | cxTranslate}}</h5>
        <h6>{{ updateInspectionData?.formattedNominationNumber }}</h6>
    </div>
</div>
<div class="modal-body ">
    <div id="loader"*ngIf="enableLoader" class="overlay-loader loading-spinner"></div>
    <div *ngIf="!enableLoader">
    <div class="col-dir col-md-12 pb-3">
        <span class="pb-2 xs-semibold-font ml-0">{{'home.recordpickup.PleaseConfirmStock' | cxTranslate}}</span>
    </div>
    <div class="mb-3 col-md-12 col-sm-12">

        <div class=" pb-2 xs-semibold-font ml-0 text-secondary" title="Draft quantity">{{ "shipment.draftSurvey" | cxTranslate }}
        <!-- Show info SVG if not validated, else show warning SVG if validation failed -->
        <!-- Info SVG before validation -->
        <img src="/images/info.svg" *ngIf="(azureStatus | lowercase)=='not_initiated'" [ngbTooltip]="'home.recordpickup.AzureNotValidated' | cxTranslate"  alt="Not yet validated" width="20px" height="20px">
        <!-- Warning SVG only after validation attempt and failure -->
        <img src="/images/warning.svg" *ngIf="(azureStatus | lowercase) === 'failure' " [ngbTooltip]="'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate" alt="Unsuccessful validation" width="20px" height="20px" >
        <!-- Success SVG only after validation attempt and success -->
        <img src="/images/check_circle.svg" *ngIf="(azureStatus | lowercase) === 'success' " [ngbTooltip]="'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate" alt="Validated successfully" width="20px" height="20px" >
        <img src="/images/pending.svg" *ngIf="(azureStatus | lowercase) === 'in_progress' " [ngbTooltip]="'home.recordpickup.AzureValidating' | cxTranslate" alt="In progress" width="20px" height="20px" >
        
        </div>
        <div class=" fs-18 ff-semibold ml-0">
            {{ formValues?.draftSurveyQty ?? updateInspectionData?.draftSurveyQty }}</div>
    </div>
    <div class="mb-3 col-md-12 col-sm-12">
        <div class=" pb-2 xs-semibold-font ml-0 text-secondary" title="Start date">{{ "shipment.startDate" | cxTranslate }}</div>
        <div class=" fs-18 ff-semibold ml-0">
            {{ formatDateWithSlash(formValues?.surveyStartDate ?? updateInspectionData?.surveyStartDate) }}</div>
    </div>
    <div class="mb-3 col-md-12 col-sm-12">
        <div class=" pb-2 xs-semibold-font ml-0 text-secondary" title="End date">{{ "shipment.endDate" | cxTranslate }}</div>
        <div class=" fs-18 ff-semibold ml-0">
            {{ formatDateWithSlash(formValues?.surveyEndDate ?? updateInspectionData?.surveyEndDate) }}</div>
    </div>
    <div class="mb-3 col-md-12 col-sm-12">
        <div class="pb-2 xs-semibold-font ml-0 text-secondary">{{'tenders.Attachment' | cxTranslate}}</div>
        <div>
            <div class="b-attachment mt-2" *ngFor="let file of attachmentsList; let i=index;">
                <div class="d-flex file-block-height">
                    <div class="d-flex w-100 m-2">
                        <div class="d-flex align-items-center"><img src="../../images/file-alt.svg" class="p-2"></div>
                        <div class="p-2 w-100 text-break">
                            <p class="file_name file-name-height-1">{{file.name || file.documentName}}</p>
                            <p class="file_size text-secondary">{{file.size / 1024 / 1024 | number: '.3'}}MB /
                                {{file.size / 1024 / 1024 | number: '.3'}}MB</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-sm-12">
        <div *ngIf="(azureStatus | lowercase)=='not_initiated'" class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/info.svg" [ngbTooltip]="'home.recordpickup.AzureNotValidated' | cxTranslate"  alt="Not yet validated" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.validationResults' | cxTranslate}}</span>

        </div>
        <div *ngIf="(azureStatus | lowercase)=='in_progress'"
          class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/pending.svg" [ngbTooltip]="'home.recordpickup.AzureValidating' | cxTranslate" alt="In progress" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.dataSubmitted' | cxTranslate}}</span>

        </div>
        <!-- Validation error message -->
        <div *ngIf="(azureStatus | lowercase) === 'failure'"
          class="text-danger mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F; border-radius: 4px; display: flex;color: #5C1715">
          <img src="/images/warning.svg" [ngbTooltip]="'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate" alt="Unsuccessful validation" width="20px" height="20px" >
          <span class="ml-2">{{updateInspectionData?.azureValidationRemark}}</span>
        </div>
        <!-- Validation success message -->
        <div *ngIf="(azureStatus | lowercase) === 'success'"
          class="text-success mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F; border-radius: 4px; display: flex;color: #28A745">
         <img src="/images/check_circle.svg" [ngbTooltip]="'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate" alt="Validated successfully" width="20px" height="20px" >
          <span class="ml-2">{{updateInspectionData?.azureValidationRemark}}</span>
        </div>
        <div class="d-flex justify-content-between">
            <div class="width-70">
                <label for="inspectionCompleted" class="pb-2 xs-semibold-font ml-0 text-secondary">{{'shipment.inspectionCompleted'|
              cxTranslate}}</label>
            </div>

            <div class="col-md-2 col-sm-2 p-0 w-50">
                <div class="btn-group btn-group-toggle float-right p-0" data-toggle="buttons">
                    <label class="btn border py-0 min-h text-secondary active_yes b-dvl unabletoclick">
                        <input type="radio" disabled /> {{'shipment.YES'|cxTranslate}}
                    </label>

                    <label class="btn border py-0 min-h text-secondary active_no b-dvl unabletoclick">
                        <input type="radio" disabled /> {{'shipment.NO'|cxTranslate}}
                    </label>
                </div>
            </div>

        </div>

        
      </div>

    <div class="col-md-12 col-sm-12">
        <div class="mt-2 p-2 d-flex" style="font-size: 0.95rem; border: 1px solid #ffc107; border-radius: 4px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 20 20" fill="none">
                <path
                    d="M3.72494 17.087H16.2749C17.5583 17.087 18.3583 15.6953 17.7166 14.587L11.4416 3.74531C10.7999 2.63698 9.19994 2.63698 8.55827 3.74531L2.28327 14.587C1.6416 15.6953 2.4416 17.087 3.72494 17.087ZM9.99994 11.2536C9.5416 11.2536 9.1666 10.8786 9.1666 10.4203V8.75365C9.1666 8.29531 9.5416 7.92031 9.99994 7.92031C10.4583 7.92031 10.8333 8.29531 10.8333 8.75365V10.4203C10.8333 10.8786 10.4583 11.2536 9.99994 11.2536ZM10.8333 14.587H9.1666V12.9203H10.8333V14.587Z"
                    fill="#ffc107" />
            </svg>
            <span class="ml-2">{{'home.recordpickup.onceSaved' | cxTranslate}}</span>
        </div>
    </div>
    </div>

  <div class="modal-footer" *ngIf="!enableLoader">
        <div class="col-md-12 col-sm-12">

            <button class="btn btn-block btn-lg  btn-primary" type="button"
                (click)="confirmCompletion()">{{'home.recordpickup.confirm' | cxTranslate}}</button>
            <button class="btn btn-block btn-light btn-lg" type="button" (click)="goBack()">{{'shipment.back'|cxTranslate}}</button>
        </div>
    </div>